var app = angular.module("leonardo");

var FolderFileAdd = function($scope, $state, folder, FolderFileService, FolderService, $rootScope, FormErrorsService) {
  $scope.action = $scope.ngDialogData.action;
  $scope.status = $scope.ngDialogData.status;

  $scope.mode = $state.current.mode ? $state.current.mode : 'normal';

  $scope.folder = folder;
  if ($scope.folder) {
    $scope.folder_file = $scope.ngDialogData.entity ? $scope.ngDialogData.entity.plain() : FolderFileService.bulkObject(folder.id);
  }
  else {
    $scope.folder_file = {};
  }

  if ($scope.action === 'edit') {
    var uri = new URI($scope.folder_file.file);
    $scope.folder_file.file = {
      name: uri.filename(),
      original: true
    };
  }

  $scope.folder_file.type = FolderFileService.TYPE_NORMAL;

  if ($scope.status === 'missing'){
    $scope.folder_file.requirement = $scope.ngDialogData.requirement.id;
  }
  if ($scope.ngDialogData.name) {
    $scope.folder_file.name = $scope.ngDialogData.name;
  }

  $scope.getData = function() {
    var data = angular.copy($scope.folder_file);
    data['file'] = $scope.folder_file.file;
    if ($scope.action !== 'resolve') {
      data['folder'] = ($scope.folder && $scope.folder.id) ? $scope.folder.id : $scope.folder;
    }
    return data;
  };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var data = $scope.getData();
    if ($scope.action === 'resolve') {
      $scope.confirm(data);
    }
    else if ($scope.action === 'create') {
      FolderFileService.post(data).then(function (folder_file) {
        $scope.closeThisDialog();
        $rootScope.$broadcast('folder-file:created', folder_file);
      });
    }
    else {
      var promise = null;
      if (data.file.original) {
        var patchData = angular.copy(data);
        delete patchData['file'];
        promise = $scope.ngDialogData.entity.patch(patchData);
      }
      else {
        promise = FolderFileService.put($scope.folder_file.id, data);
      }
      promise.then(function (folder_file) {
        $scope.closeThisDialog();
        $rootScope.$broadcast('folder-file:updated', folder_file);
      });
    }
  };
};

app.controller('FolderFileAdd', ['$scope', '$state', 'folder', 'FolderFileService', 'FolderService', '$rootScope',
  'FormErrorsService', FolderFileAdd]);
